export default __webpack_public_path__ + "static/media/emptyOn.0c3a31f3.svg";